<div class="block legal-container">
	<div class="copo-grid-row copo-grid-row-stretch">
		<div class="copo-grid-row-column copo-grid-row-2-columns">
			<div class="legal-documents-title">
				<span translate>settings.generalSalesCondition</span>
			</div>
			<copo-loading-spinner class="loading-spinner-container" *ngIf="isLoadingGsc"></copo-loading-spinner>
			<div *ngFor="let gscDocument of getSortedLegalDocumentList(legalDocumentsGSC)" class="legal-documents-item">
				<div class="legal-documents-file-title">
					{{ getDocumentTitle(gscDocument.files) }}
				</div>
				<a *ngFor="let file of gscDocument.files"
					class="legal-documents-file-link settings-text-underlined" mat-ripple
					[href]="getURL(file, gscDocument.id) | copoSafeUrl" target="_blank" type="application/pdf">
					{{ getLang(file.lang) }}
				</a>
			</div>
			<span class="no-docs-message" *ngIf="!isLoadingGsc && legalDocumentsGSC.length < 1"
				translate>no.legal.documents</span>
		</div>

		<div class="copo-grid-row-column copo-grid-row-2-columns">
			<div class="copo-grid-row-column copo-grid-row-2-columns">
				<div class="legal-documents-title">
					<span translate>settings.sales.framework</span>
				</div>
				<copo-loading-spinner class="loading-spinner-container" *ngIf="isLoadingSf"></copo-loading-spinner>
				<div *ngFor="let sfDocument of legalDocumentsSF" class="legal-documents-item">
					<div class="legal-documents-file-title">
						{{ getDocumentTitle(sfDocument.files) }}
					</div>
					<a *ngFor="let file of sfDocument.files"
						class="legal-documents-file-link settings-text-underlined" mat-ripple
						[href]="getURL(file, sfDocument.id) | copoSafeUrl" target="_blank" type="application/pdf">
						{{ getLang(file.lang) }}
					</a>
				</div>
				<span class="no-docs-message" *ngIf="!isLoadingSf && legalDocumentsSF.length < 1" translate>
					no.legal.documents</span>
			</div>

			<div class="copo-grid-row-column copo-grid-row-2-columns">
				<div class="legal-documents-title">
					<span translate>settings.terms.of.use</span>
				</div>
				<copo-loading-spinner class="loading-spinner-container" *ngIf="isLoadingTou"></copo-loading-spinner>
				<div *ngFor="let termsOfUse of legalDocumentsTOU" class="legal-documents-item">
					<div class="legal-documents-file-title">
						{{ getDocumentTitle(termsOfUse.files) }}
					</div>
					<a *ngFor="let termsOfUseFile of termsOfUse.files"
						class="legal-documents-file-link settings-text-underlined" mat-ripple
						[href]="getURL(termsOfUseFile, termsOfUse.id) | copoSafeUrl" target="_blank" type="application/pdf">
						{{ getLang(termsOfUseFile.lang) }}
					</a>
				</div>
				<span class="no-docs-message" *ngIf="!isLoadingTou && legalDocumentsTOU.length < 1"
					translate>no.legal.documents</span>
			</div>
		</div>
	</div>
</div>